import React from "react";

import { PhaseInner, SolverPhaseInputGroupWrapper } from "@/components/sections/SolverPhases.tsx";
import type { SolverPhasesSelectionProps } from "@/components/sections/SolverPhasesSelection.types.tsx";



/**
 * Main component
 * @param param0
 * @returns 
 */
const SolverPhasesSelection: React.FC<SolverPhasesSelectionProps> = (props) => {

    //const [editData , setEditData] = useState({...{},...solverConfigs});
    const ctrl =props.controller;
  //  const setEditData = ctrl.setEditData;
   // const editData = ctrl.editData;
    const viewData = ctrl.viewData;

    return (
         <div className="text-gray-700">
                <div>
                    <span className="text-base font-bold">Phases</span>
                </div>
                {
                    viewData.listOfUIPhases.map((item)=>{
                        return  <SolverPhaseInputGroupWrapper key={item.id} onClick={() => props.selectPhase(item.id)}>
                            <PhaseInner
                                title={item.name}
                                selectable={true}
                                configurable={false}
                                checked={item.id === viewData.selectedPhaseId}
                                // onChange={(e) => props.selectPhase(item.id)}
                                onChange={(e) => {}}
                            />
                        </SolverPhaseInputGroupWrapper>

                    })
                }
         </div>
    );
};

export default SolverPhasesSelection;
